module.exports = __webpack_public_path__ + "img/scene_14.a82a4cc2.jpg";